import Utils from '../../Utils';

export default {
    projectCount: state => {
        return state.projects.length;
    },

    currentProject: state => {
        return state.currentProject;
    },

    enaioRootObject: state => {
        return state.currentProject.rawRoot;
    },

    projectData: state => {
        return state.currentProject.projectData;
    },

    projectFiles: state => {
        return state.currentProject.rootFile;
    },

    projectTaskLists: state => {
        return state.currentProject.taskLists;
    },

    projectCollaborators: state => {
        return Utils.checkDuplicateProperty('displayName', state.currentProject.collaborators);
    },

    projectCollaborator(state) {
        return function(args) {
            return state.currentProject.collaborators.find(x => x.id === args);
        };
    },

    isUploadConfigured: state => {
        return (state.currentProject.projectData.importDocumentType && state.currentProject.projectData.importDocumentType > 0);
    },

    isProjectOwner: (state, getters, rootState) => {
        if (state.currentProject.collaborators) {
            let owners = state.currentProject.collaborators.filter(item => item.membership === 'OWNER');
            if (owners) {
                let owner = owners.find(item => item.id == rootState.userData.data.id);
                if (owner) {
                    return true;
                }
            }
        }

        if (rootState.userData.data) {
            return (rootState.userData.data.id === state.currentProject.projectData.ownerId);
        }
    },

    isGuestUser: (state, getters, rootState) => {
        let isGuest = undefined;
        if (state.currentProject.collaborators) {
            let guests = state.currentProject.collaborators.filter(item => item.membership === 'GUEST');
            if (guests) {
                let guest = guests.find(item => item.id == rootState.userData.data.id);
                if (guest) {
                    isGuest = true;
                } else {
                    isGuest = false;
                }
            }
        }

        return isGuest;
    },

    openTasksNumber: state => {
        if (state.currentProject.assignedTaskLists) {
            let sum = state.currentProject.assignedTaskLists.reduce(function(acc, val) {
                return acc + val.tasks.length;
            }, 0);

            return sum;
        }
        
        return 0;
    },

    isColabTypeAvailable: state => {
        switch (state.currentProject.uploadStatus) {
            case 'QUALIFIED':
                return true;
            case 'NOT_QUALIFIED':
                return false;
            case 'IN_PROGRESS':
                return null;
            default: 
                return null;
        }
    }
};
